import { Injectable, OnDestroy } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class AlarmService implements OnDestroy {
  private alarmAudio: HTMLAudioElement | null = null;
  private alarmEnabled = true; // default, will be updated by settings

  constructor() {
    this.initializeAudio();
  }

  setEnabled(value: boolean) {
    this.alarmEnabled = value;
    if (!value) {
      this.stop(); // hard stop if disabled
    }
  }

  private initializeAudio() {
    this.alarmAudio = new Audio('assets/sounds/alert-alarm.wav');
    this.alarmAudio.loop = true;
  }

  play() {
    if (!this.alarmEnabled) {
      return; // ❗ prevents sound from starting when disabled
    }

    if (!this.alarmAudio) {
      this.initializeAudio();
    }

    this.alarmAudio!.play().catch(err => {
      console.error('Error playing alarm:', err);
    });
  }

  stop() {
    if (this.alarmAudio) {
      this.alarmAudio.pause();
      this.alarmAudio.currentTime = 0;
      this.alarmAudio.loop = false;
      this.alarmAudio.src = '';
      this.alarmAudio.load();
      this.alarmAudio = null;
    }
  }

  ngOnDestroy() {
    this.stop();
    this.alarmAudio = null;
  }
}

